import { useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import AdModal from "./AdModal";
import useWindowWidth from "helpers/useWindowWidth";

const SESSION_KEY = "modal_shown_this_session";

const SessionModalManager = ({data}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const timeoutRef = useRef(null);
  const inactivityRef = useRef(null);
  const width = useWindowWidth();

  useEffect(() => {
    // Show modal after 20s (only once per session)
    if (!sessionStorage.getItem(SESSION_KEY)) {
      timeoutRef.current = setTimeout(() => {
        showModal();
        sessionStorage.setItem(SESSION_KEY, "true");
      }, 20000);
    // }, 5000);
    }

    // Start 30s inactivity timer
    startInactivityTimer();

    // Reset inactivity timer on user interaction
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((e) =>
      window.addEventListener(e, resetInactivityTimer)
    );

    return () => {
      clearTimeout(timeoutRef.current);
      clearTimeout(inactivityRef.current);
      events.forEach((e) =>
        window.removeEventListener(e, resetInactivityTimer)
      );
    };
  }, []);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleClose = () => {
    setIsModalVisible(false);
  };

  const startInactivityTimer = () => {
    inactivityRef.current = setTimeout(() => {
      showModal();
    }, 30000); // 30s
  };

  const resetInactivityTimer = () => {
    clearTimeout(inactivityRef.current);
    startInactivityTimer();
  };

  return (
    <Modal
      open={isModalVisible}
      onCancel={handleClose}
      onOk={handleClose}
      footer={null}
      width = {width> 900 ? 800 : "90%"}
      className="initial-popup-modal"
      bodyStyle={{ overflowY: "auto" }} // Ensure content is scrollable if long
    >
      <AdModal data = {data} />
    </Modal>
  );
};

export default SessionModalManager;
